import { render, staticRenderFns } from "./xxy-event.vue?vue&type=template&id=2fb2c94c&scoped=true"
import script from "./xxy-event.vue?vue&type=script&lang=js"
export * from "./xxy-event.vue?vue&type=script&lang=js"
import style0 from "./xxy-event.vue?vue&type=style&index=0&id=2fb2c94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2c94c",
  null
  
)

export default component.exports